import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg bg-secondary-subtle" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "admin_navbar"
}
const _hoisted_4 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_15 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_16 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_17 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_18 = { class: "nav-item" }

import {computed, reactive} from "vue";
import {useRoute} from "vue-router";

import {useMainStore} from "@/stores/mainStore";


interface State {
    isAdmin: boolean
    isContributor: boolean
    isEconomist: boolean
}



export default /*@__PURE__*/_defineComponent({
  __name: 'AdminNavbar',
  setup(__props) {

const route = useRoute();
const mainStore = useMainStore();


const state: State = reactive({
    isAdmin: computed(() => mainStore.isAdmin),
    isContributor: computed(() => mainStore.isContributor),
    isEconomist: computed(() => mainStore.isEconomist),
})



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "navbar-brand" }, "Contributor admin", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#admin_navbar",
        "aria-controls": "admin_navbar",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: {name: 'dashboard'},
              class: _normalizeClass([{'active': _unref(route).name === 'dashboard'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Dashboard ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          (state.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: {name: 'usersAdminList'},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'users'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Users ", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          (state.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: {name: 'jurisdictions'},
                  class: _normalizeClass([{'active': _unref(route).name === 'jurisdictions'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Jurisdictions ", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: {name: state.isEconomist ? 'economistsConsultancyListView' : 'lawFirmsListView'},
              class: _normalizeClass([{'active': _unref(route).meta.submodule === 'experts'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Experts ", -1)
              ]))]),
              _: 1
            }, 8, ["to", "class"])
          ]),
          (state.isAdmin || state.isContributor)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: {name: 'competitionAuthorities'},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'authorities'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Authorities ", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          (state.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: {name: 'newsList'},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'news'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" News ", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: {name: 'jobsList'},
              class: _normalizeClass([{'active': _unref(route).meta.submodule === 'jobs'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Jobs ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: {name: 'eventsList'},
              class: _normalizeClass([{'active': _unref(route).meta.submodule === 'events'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Events ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: {name: 'articlesList'},
              class: _normalizeClass([{'active': _unref(route).meta.submodule === 'articles'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Articles ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          (state.isAdmin || state.isContributor)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: {name: 'decisionsListView'},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'decisions'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Decisions ", -1)
                  ]))]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          (state.isAdmin || state.isContributor)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: {name:  (state.isAdmin ? 'mergerHeadings' : 'mergerGuide')},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'guidesmerger'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Merger Control ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to", "class"])
              ]))
            : _createCommentVNode("", true),
          (state.isAdmin || state.isContributor)
            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: {name: (state.isAdmin ? 'foreignHeadings' : 'foreignGuide')},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'guidesforeign'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Foreign Investments ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to", "class"])
              ]))
            : _createCommentVNode("", true),
          (state.isAdmin || state.isContributor)
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: {name: state.isAdmin ? 'mailingListAdmin' : 'newsletterAdmin'},
                  class: _normalizeClass([{'active': _unref(route).meta.submodule === 'newsletter'}, "nav-link"])
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Newsletter ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to", "class"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: {name: 'analytics'},
              class: _normalizeClass([{'active': _unref(route).name === 'analytics'}, "nav-link"])
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" Analytics ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ])
    ])
  ]))
}
}

})